import FreeProducts from 'merchandise-lib/constants/FreeProduct';
import Products from 'merchandise-lib/constants/Product';
import * as ProductLines from './ProductLines';
import { CMS_PROFESSIONAL, COMMERCE_PROFESSIONAL, MARKETING, OPERATIONS_STARTER, SALES, SERVICE } from './UpgradeProducts';
const ProductLineMap = {
  [ProductLines.MARKETING]: {
    highlightedPaidProducts: [Products.MARKETING_HUB_STARTER, Products.MARKETING_HUB_PROFESSIONAL, Products.MARKETING_HUB_ENTERPRISE],
    highlightedFreeProduct: FreeProducts.HUBSPOT_FREE,
    upgradeProduct: MARKETING
  },
  [ProductLines.SALES]: {
    highlightedPaidProducts: [Products.SALES_HUB_STARTER, Products.SALES_HUB_PROFESSIONAL, Products.SALES_HUB_ENTERPRISE],
    highlightedFreeProduct: FreeProducts.HUBSPOT_FREE,
    upgradeProduct: SALES
  },
  [ProductLines.SERVICE]: {
    highlightedPaidProducts: [Products.SERVICE_HUB_STARTER, Products.SERVICE_HUB_PROFESSIONAL, Products.SERVICE_HUB_ENTERPRISE],
    highlightedFreeProduct: FreeProducts.HUBSPOT_FREE,
    upgradeProduct: SERVICE
  },
  [ProductLines.CMS]: {
    highlightedPaidProducts: [Products.CMS_HUB_STARTER, Products.CMS_HUB_PROFESSIONAL, Products.CMS_HUB_ENTERPRISE],
    highlightedFreeProduct: FreeProducts.HUBSPOT_FREE,
    upgradeProduct: CMS_PROFESSIONAL
  },
  [ProductLines.OPERATIONS]: {
    highlightedPaidProducts: [Products.OPERATIONS_HUB_STARTER, Products.OPERATIONS_HUB_PROFESSIONAL, Products.OPERATIONS_HUB_ENTERPRISE],
    highlightedFreeProduct: FreeProducts.HUBSPOT_FREE,
    upgradeProduct: OPERATIONS_STARTER
  },
  [ProductLines.COMMERCE]: {
    highlightedPaidProducts: [Products.COMMERCE_HUB_PROFESSIONAL, Products.COMMERCE_HUB_ENTERPRISE],
    highlightedFreeProduct: FreeProducts.HUBSPOT_FREE,
    upgradeProduct: COMMERCE_PROFESSIONAL
  }
};
export const FullProductLineMap = {
  [ProductLines.MARKETING]: {
    highlightedFreeProduct: FreeProducts.MARKETING_HUB_FREE,
    highlightedProducts: [Products.MARKETING_HUB_STARTER, Products.MARKETING_HUB_PROFESSIONAL, Products.MARKETING_HUB_ENTERPRISE],
    upgradeProduct: MARKETING
  },
  [ProductLines.SALES]: {
    highlightedFreeProduct: FreeProducts.SALES_HUB_FREE,
    // Not in API yet (Features nor Products)
    highlightedProducts: [Products.SALES_HUB_STARTER, Products.SALES_HUB_PROFESSIONAL, Products.SALES_HUB_ENTERPRISE],
    upgradeProduct: SALES
  },
  [ProductLines.SERVICE]: {
    highlightedFreeProduct: FreeProducts.SERVICE_HUB_FREE,
    highlightedProducts: [Products.SERVICE_HUB_STARTER, Products.SERVICE_HUB_PROFESSIONAL, Products.SERVICE_HUB_ENTERPRISE],
    upgradeProduct: SERVICE
  },
  [ProductLines.CMS]: {
    highlightedFreeProduct: FreeProducts.CMS_HUB_FREE,
    highlightedProducts: [Products.CMS_HUB_STARTER, Products.CMS_HUB_PROFESSIONAL, Products.CMS_HUB_ENTERPRISE],
    upgradeProduct: CMS_PROFESSIONAL
  },
  [ProductLines.OPERATIONS]: {
    highlightedFreeProduct: FreeProducts.OPERATIONS_HUB_FREE,
    // Not in API yet (Features nor Products)
    highlightedProducts: [Products.OPERATIONS_HUB_STARTER, Products.OPERATIONS_HUB_PROFESSIONAL, Products.OPERATIONS_HUB_ENTERPRISE],
    upgradeProduct: OPERATIONS_STARTER
  },
  [ProductLines.COMMERCE]: {
    highlightedFreeProduct: FreeProducts.COMMERCE_HUB_FREE,
    highlightedProducts: [Products.COMMERCE_HUB_PROFESSIONAL, Products.COMMERCE_HUB_ENTERPRISE],
    upgradeProduct: COMMERCE_PROFESSIONAL
  }
};
export const FullProductLineMapV2 = {
  [ProductLines.MARKETING]: {
    highlightedFreeProduct: FreeProducts.MARKETING_HUB_FREE,
    highlightedProducts: [Products.MARKETING_HUB_STARTER, Products.MARKETING_HUB_PROFESSIONAL, Products.MARKETING_HUB_ENTERPRISE],
    upgradeProduct: MARKETING
  },
  [ProductLines.SALES]: {
    highlightedFreeProduct: FreeProducts.SALES_HUB_FREE,
    // Not in Merchandise yet, this is strictly used to access feature store
    highlightedProducts: [Products.SALES_HUB_STARTER, Products.SALES_HUB_PROFESSIONAL, Products.SALES_HUB_ENTERPRISE],
    upgradeProduct: SALES
  },
  [ProductLines.SERVICE]: {
    highlightedFreeProduct: FreeProducts.SERVICE_HUB_FREE,
    highlightedProducts: [Products.SERVICE_HUB_STARTER, Products.SERVICE_HUB_PROFESSIONAL, Products.SERVICE_HUB_ENTERPRISE],
    upgradeProduct: SERVICE
  },
  [ProductLines.CMS]: {
    highlightedFreeProduct: FreeProducts.CMS_HUB_FREE,
    highlightedProducts: [Products.CMS_HUB_STARTER, Products.CMS_HUB_PROFESSIONAL, Products.CMS_HUB_ENTERPRISE],
    upgradeProduct: CMS_PROFESSIONAL
  },
  [ProductLines.OPERATIONS]: {
    highlightedFreeProduct: FreeProducts.OPERATIONS_HUB_FREE,
    // Not in Merchandise yet, this is strictly used to access feature store
    highlightedProducts: [Products.OPERATIONS_HUB_STARTER, Products.OPERATIONS_HUB_PROFESSIONAL, Products.OPERATIONS_HUB_ENTERPRISE],
    upgradeProduct: OPERATIONS_STARTER
  },
  [ProductLines.COMMERCE]: {
    highlightedFreeProduct: FreeProducts.COMMERCE_HUB_FREE,
    // Not in Merchandise yet, this is strictly used to access feature store
    highlightedProducts: [Products.COMMERCE_HUB_PROFESSIONAL, Products.COMMERCE_HUB_ENTERPRISE],
    upgradeProduct: COMMERCE_PROFESSIONAL
  }
};
export default ProductLineMap;